import { ArrowRight } from 'lucide-react';
import { Link } from '@tanstack/react-router';

const zhPages = [
  { key: 'services', label: '服務列表', href: '/services', description: '了解網站、SEO 及廣告服務' },
  { key: 'pricing', label: '價錢詳情', href: '/pricing', description: '查看網頁設計價錢及報價方向' },
  { key: 'cases', label: '案例作品', href: '/cases', description: '參考真實網站案例及做法' },
  { key: 'blog', label: '渡橋網誌', href: '/blog', description: '閱讀網站、SEO 及廣告攻略' },
] as const;

const enPages = [
  { key: 'services', label: 'Services', href: '/en/services', description: 'Explore website, SEO and advertising services' },
  { key: 'pricing', label: 'Pricing', href: '/en/pricing', description: 'View website prices and quotation principles' },
  { key: 'cases', label: 'Cases', href: '/en/cases', description: 'Review real website examples and approaches' },
  { key: 'blog', label: 'Doq Creative Blog', href: '/en/blog', description: 'Read website, SEO, advertising and ERP guides' },
] as const;

export function PublicCrossLinks({ current, locale = 'zh' }: { current: (typeof zhPages)[number]['key']; locale?: 'zh' | 'en' }) {
  const pages = locale === 'en' ? enPages : zhPages;
  return (
    <nav aria-label={locale === 'en' ? 'Main site content' : '網站主要內容'} className="border-y border-[#143d35]/14 px-5 py-8 sm:px-8 lg:px-24">
      <div className="flex flex-wrap gap-x-6 gap-y-4">
        {pages.filter((page) => page.key !== current).map((page) => (
          <Link key={page.key} to={page.href} className="group inline-flex min-w-[190px] flex-1 items-center justify-between gap-4 border-b border-[#143d35]/18 pb-3 text-sm hover:border-[#815321]">
            <span><span className="block font-semibold text-[#102d28]">{page.label}</span><span className="mt-1 block text-xs text-[#52635c]">{page.description}</span></span>
            <ArrowRight className="size-4 shrink-0 text-[#815321] transition group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </nav>
  );
}
